import moment, { Moment } from "moment";

// Date and Time Utilities

// 09/22/2022 00:00:25   mm/dd/yyyy h:mm:ss A
export const __formatDate24HourUS = (date: string | Date) => {
    if (!(date instanceof Date)) {
        date = new Date(date);
    }
    const formattedDate = moment(date).format('MM/DD/YYYY, h:mm:ss A');
    return formattedDate;
};

// 11/03/2022   Turns mm-dd-yyyy into => mm/dd/yyyy
export const __formatDateMM_DD_YYYY_US = (date: string | Date) => {

    const isHyphenFormat = __isDateValidMM_DD_YYYY(date.toString());
    if (isHyphenFormat) {
        const dates = date.toString().split('-');
        const mm = dates[0];
        const dd = dates[1];
        const yyyy = dates[2];
        return `${mm}/${dd}/${yyyy}`;
    }

    const formattedDate = moment(date).format('MM/DD/YYYY');
    return formattedDate;
};

// 11-03-2022 Turns mm-dd-yyyy into => yyyy-mm-dd (for default HTML Date input)
export const __formatDateYYYY_MM_DD = (dateStr: string) => {
    const dates = dateStr.split('-');
    const mm = dates[0];
    const dd = dates[1];
    const yyyy = dates[2];

    return `${yyyy}-${mm}-${dd}`;
};

// 3:08PM  hh/mm AM|PM
export const __formatTimeHH_MM_Meridian = (date: string | Date) => {
    const formattedTime = moment(date).format('h:mm A');
    return formattedTime;
};

export const __isDateValidYYYY_MM_DD = (dateStr: string) => {
    // Desired Format => 2022-11-17 
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (dateStr.match(regex) === null) {
        return false;
    }

    const date = new Date(dateStr);
    const timestamp = date.getTime();
    if (typeof timestamp !== 'number' || Number.isNaN(timestamp)) {
        return false;
    }

    return date.toISOString().startsWith(dateStr);
};

export const __isDateValidMM_DD_YYYY = (dateStr: string) => {
    // Desired Format => 11-10-2022
    const valid = moment(dateStr, 'MM-DD-YYYY', true).isValid();
    return valid;
};

export const __isDateRangeValid = (dateVal: string) => {
    // 11-02-2022
    const dates = dateVal.split('..');
    if (!__isDateValidMM_DD_YYYY(dates[0]) || !__isDateValidMM_DD_YYYY(dates[1])) {
        return false;
    }
    return true;
};

// is A Moment date after B Moment Date
export const __findLaterDate = (dateA: Moment, dateB: Moment) => {
    //String is already in utc time, but still need to put it into utc mode
    const date_a = moment.utc(dateA, 'YYYY-MM-DD[T]HH:mm[Z]');
    //Convert current time to moment object with utc time
    const date_b = moment.utc(dateB, 'YYYY-MM-DD[T]HH:mm[Z]');

    return date_a.isAfter(date_b);
};